import { config } from '@psl/functions/config';
import { NavigationContainerRef } from '@react-navigation/core';
import { CaptureConsole } from '@sentry/integrations';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { Fragment } from 'react';
import { LogBox } from 'react-native';
import { current } from '../../version.json';
import {
  getSentryDsn,
  SentryPerformanceTracking,
} from './crashTracking.shared';

LogBox.ignoreLogs([
  'Non-serializable values were found in the navigation state',
  /Tried to set property `_css/,
  /VirtualizedLists should never be nested inside plain ScrollViews/,
  /SplashScreen.show/,
  /Require cycle: src\/flows\/discovery\/DiscoveryPage.tsx/,
  /externalScrollView/,
  /Names should contain 1 to 40/,
]);

export const setupCrashTracking = () => {
  if (__DEV__) {
    return;
  }
  Sentry.init({
    environment: config.env || 'unknown',
    release: current,
    dsn: getSentryDsn(),
    integrations: [
      new Integrations.BrowserTracing(),
      new CaptureConsole({ levels: ['error'] }),
    ],
    tracesSampleRate: 0.1,
    ignoreErrors: [
      /AbortError: The operation was aborted/,
      /doesn't not exist on our record/,
      /NotAllowedError: The request is not allowed by the user agent/,
      /AbortError: The play/,
      /doesn't not exist on our record/,
      /Names should contain 1 to 40/,
    ],
  });
};

export function setCrashUser(uid?: string) {
  Sentry.setUser(uid != null ? { id: uid } : null);
}

export const fakeCrash = () => {
  throw new Error('Fake Crash');
};

export const fakeNativeCrash = () => {
  alert('Native crash not supported on web');
};

export const withErrorBoundary = Sentry.withErrorBoundary;
export const TouchEventBoundary = Fragment;

export const captureException = (err: any) => {
  Sentry.captureException(err);
};

export const trackNavigatorPerformance = (
  _navigator: NavigationContainerRef<any>,
) => {
  // noop
};

export const captureCrashTrackingEvent = (event: Sentry.Event) => {
  Sentry.captureEvent(event);
};

export const performanceTracking: SentryPerformanceTracking = Sentry as any;
